module.exports = __webpack_public_path__ + "static/media/media-shake.8d2fe713.png";